import script from "./ProjectTemplateManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTemplateManager.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTemplateManager.vue?vue&type=style&index=0&id=c2ab9812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ab9812"]])

export default __exports__